import { useState, useEffect } from 'react';
import MetaMaskSDK from '@metamask/sdk';
import { ethers } from "ethers";
import LateralPanel from "./components/Menu/LateralPanel";
import Content from "./components/Main/Content";
import PopupWindow from "./components/PopupWindow";

let listLicenses = [
    {
        id: 1,
        name: "FileSecure Pro",
        category: "ByteTech",
        status: "Activated",
        description: "Robust file encryption software.",
        expiration_date: "2024-08-15"
    },
    {
        id: 2,
        name: "DataSync Lite",
        category: "CloudSolutions Inc.",
        status: "Expired",
        description: "Lightweight data synchronization software.",
        expiration_date: "2022-11-30"
    },
    {
        id: 3,
        name: "CodeShield Enterprise",
        category: "CyberGuardian",
        status: "Purchased",
        description: "Enterprise-level code analysis and vulnerability scanning.",
        expiration_date: "-"
    },
    {
        id: 4,
        name: "TimeTracker Plus",
        category: "SoftWorks Co.",
        status: "Activated",
        description: "Comprehensive time tracking and productivity software.",
        expiration_date: "2025-03-22"
    },
    {
        id: 5,
        name: "ImageEnhancer Pro",
        category: "Visionary Systems",
        status: "Expired",
        description: "Professional image editing software.",
        expiration_date: "2023-04-12"
    },
    {
        id: 6,
        name: "ConnectMaster Deluxe",
        category: "InnovateTech Solutions",
        status: "Purchased",
        description: "Feature-rich network management software.",
        expiration_date: "-"
    },
    {
        id: 7,
        name: "NetShield Firewall",
        category: "NetSecure",
        status: "Activated",
        description: "Robust firewall software.",
        expiration_date: "2024-02-28"
    },
    {
        id: 8,
        name: "DataAnalyzer Pro",
        category: "DataSoft Technologies",
        status: "Expired",
        description: "Powerful data analysis software.",
        expiration_date: "2023-01-19"
    },
    {
        id: 9,
        name: "QuantumTask Manager",
        category: "Quantum Solutions",
        status: "Activated",
        description: "Comprehensive task management software.",
        expiration_date: "N/A (Perpetual license)"
    },
    {
        id: 10,
        name: "CodeGenius IDE",
        category: "CodeGenius Inc.",
        status: "Purchased",
        description: "Powerful integrated development environment.",
        expiration_date: "2024-07-10"
    },
    {
        id: 11,
        name: "SmartSync Pro",
        category: "SmartApps Ltd.",
        status: "Expired",
        description: "Versatile file synchronization software.",
        expiration_date: "2022-08-05"
    },
    {
        id: 12,
        name: "OptiTask Scheduler",
        category: "TechOptimal Solutions",
        status: "Purchased",
        description: "Efficient task scheduling software.",
        expiration_date: "-"
    },
    {
        id: 13,
        name: "SecureVault Pro",
        category: "SecureNet",
        status: "Activated",
        description: "Robust data encryption and secure storage.",
        expiration_date: "2024-11-02"
    },
    {
        id: 14,
        name: "DataProfiler Lite",
        category: "InfoTech Innovators",
        status: "Expired",
        description: "User-friendly data profiling software.",
        expiration_date: "2021-10-17"
    },
    {
        id: 15,
        name: "LogicBuilder Pro",
        category: "LogicMaster",
        status: "Purchased",
        description: "Powerful visual programming software.",
        expiration_date: "-"
    },
    {
        id: 16,
        name: "LinkSync Enterprise",
        category: "SoftLink Solutions",
        status: "Activated",
        description: "Comprehensive data integration software.",
        expiration_date: "2025-05-09"
    },
    {
        id: 17,
        name: "DataSafe Backup",
        category: "DataGuard Technologies",
        status: "Expired",
        description: "Reliable data backup software.",
        expiration_date: "2022-07-25"
    },
    {
        id: 18,
        name: "OptiPlan Pro",
        category: "OptiTech Systems",
        status: "Activated",
        description: "Advanced project planning and scheduling software.",
        expiration_date: "N/A (Perpetual license)"
    },
    {
        id: 19,
        name: "StreamTask Manager",
        category: "Streamline Solutions",
        status: "Activated",
        description: "Streamlined task management software.",
        expiration_date: "2024-12-18"
    },
    {
        id: 20,
        name: "IntelliSync Lite",
        category: "IntelliSys Inc.",
        status: "Expired",
        description: "Lightweight synchronization software.",
        expiration_date: "2022-12-04"
    },
    {
        id: 21,
        name: "CyberShield Pro",
        category: "CyberSecPro",
        status: "Purchased",
        description: "Comprehensive cybersecurity software.",
        expiration_date: "-"
    },
    {
        id: 22,
        name: "DataAnalyzer Enterprise",
        category: "DataStream Technologies",
        status: "Activated",
        description: "Powerful data analysis and visualization software.",
        expiration_date: "N/A (Perpetual license)"
    },
    {
        id: 23,
        name: "CodeInsight Pro",
        category: "CodeCrafters Ltd.",
        status: "Expired",
        description: "Intelligent code analysis and review software.",
        expiration_date: "2023-02-08"
    },
    {
        id: 24,
        name: "TechMonitor Deluxe",
        category: "TechSolutions Inc.",
        status: "Activated",
        description: "Comprehensive system monitoring software.",
        expiration_date: "N/A (Perpetual license)"
    },
    {
        id: 25,
        name: "SecureConnect Enterprise",
        category: "SecureSoft Systems",
        status: "Activated",
        description: "Secure remote access software.",
        expiration_date: "2024-06-20"
    }
]

let listExplore = [
    {
        name: "DataGuard Pro",
        enterprise: "DataGuard Technologies",
        description: "Comprehensive data protection and encryption software.",
        duration: "12 months",
        price: "0.25 ETH"
    },
    {
        name: "CloudSync Enterprise",
        enterprise: "CloudTech Solutions",
        description: "Robust cloud synchronization and backup software.",
        duration: "18 months",
        price: "0.375 ETH"
    },
    {
        name: "LogicBuilder Pro",
        enterprise: "LogicMaster",
        description: "Powerful visual programming software.",
        duration: "24 months",
        price: "0.5 ETH"
    },
    {
        name: "SecureNet Suite",
        enterprise: "SecureNet Solutions",
        description: "Integrated suite of network security tools.",
        duration: "12 months",
        price: "0.225 ETH"
    },
    {
        name: "CodeInspector Pro",
        enterprise: "CodeCrafters Ltd.",
        description: "Advanced code analysis and debugging software.",
        duration: "6 months",
        price: "0.175 ETH"
    },
    {
        name: "StreamTask Manager",
        enterprise: "Streamline Solutions",
        description: "Streamlined task management software.",
        duration: "18 months",
        price: "0.325 ETH"
    },
    {
        name: "CyberShield Pro",
        enterprise: "CyberSecPro",
        description: "Comprehensive cybersecurity software.",
        duration: "12 months",
        price: "0.25 ETH"
    },
    {
        name: "DataAnalyzer Enterprise",
        enterprise: "DataStream Technologies",
        description: "Powerful data analysis and visualization software.",
        duration: "24 months",
        price: "0.5 ETH"
    },
    {
        name: "OptiPlan Pro",
        enterprise: "OptiTech Systems",
        description: "Advanced project planning and scheduling software.",
        duration: "12 months",
        price: "0.225 ETH"
    },
    {
        name: "SyncConnect Lite",
        enterprise: "SyncTech Solutions",
        description: "Lightweight file synchronization software.",
        duration: "6 months",
        price: "0.15 ETH"
    },
    {
        name: "IntelliSecure Pro",
        enterprise: "IntelliSec Solutions",
        description: "Intelligent data security and encryption software.",
        duration: "18 months",
        price: "0.375 ETH"
    },
    {
        name: "DataProfiler Enterprise",
        enterprise: "InfoTech Innovators",
        description: "Comprehensive data profiling and analysis software.",
        duration: "24 months",
        price: "0.5 ETH"
    },
    {
        name: "SecureLink Enterprise",
        enterprise: "SecureSoft Systems",
        description: "Secure remote access and collaboration software.",
        duration: "12 months",
        price: "0.25 ETH"
    },
    {
        name: "DataGuard Lite",
        enterprise: "DataGuard Technologies",
        description: "Lightweight data protection and backup software.",
        duration: "6 months",
        price: "0.175 ETH"
    },
    {
        name: "OptiTrack Pro",
        enterprise: "OptiTech Systems",
        description: "Advanced asset tracking and management software.",
        duration: "18 months",
        price: "0.325 ETH"
    },
    {
        name: "SyncMate Pro",
        enterprise: "SyncTech Solutions",
        description: "Synchronization software for multiple devices.",
        duration: "12 months",
        price: "0.225 ETH"
    },
    {
        name: "CodeMaster Enterprise",
        enterprise: "CodeCrafters Ltd.",
        description: "Comprehensive integrated development environment.",
        duration: "24 months",
        price: "0.5 ETH"
    },
    {
        name: "CyberGuard Pro",
        enterprise: "CyberSecPro",
        description: "Advanced cybersecurity suite with real-time protection.",
        duration: "12 months",
        price: "0.25 ETH"
    },
    {
        name: "DataFlow Manager",
        enterprise: "DataStream Technologies",
        description: "Streamline and manage data flow across systems.",
        duration: "18 months",
        price: "0.375 ETH"
    },
    {
        name: "AppSecure Pro",
        enterprise: "AppTech Solutions",
        description: "Comprehensive application security software.",
        duration: "12 months",
        price: "0.25 ETH"
    },
    {
        name: "DataHub Enterprise",
        enterprise: "DataStream Technologies",
        description: "Centralized data management and integration software.",
        duration: "24 months",
        price: "0.5 ETH"
    },
    {
        name: "AIAnalyzer Pro",
        enterprise: "AI Innovators",
        description: "Advanced artificial intelligence analysis software.",
        duration: "12 months",
        price: "0.225 ETH"
    },
    {
        name: "NetGuard Suite",
        enterprise: "SecureNet Solutions",
        description: "Comprehensive network security suite.",
        duration: "6 months",
        price: "0.175 ETH"
    },
    {
        name: "CloudBackup Pro",
        enterprise: "CloudTech Solutions",
        description: "Reliable cloud backup and recovery software.",
        duration: "18 months",
        price: "0.325 ETH"
    },
    {
        name: "CodeOptimizer Pro",
        enterprise: "CodeCrafters Ltd.",
        description: "Advanced code optimization software.",
        duration: "12 months",
        price: "0.25 ETH"
    },
    {
        name: "SecureID Enterprise",
        enterprise: "CyberSecPro",
        description: "Secure identity and access management software.",
        duration: "24 months",
        price: "0.5 ETH"
    },
    {
        name: "DataMaster Pro",
        enterprise: "DataTech Systems",
        description: "Comprehensive data management and analysis software.",
        duration: "12 months",
        price: "0.225 ETH"
    },
    {
        name: "SyncPro Enterprise",
        enterprise: "SyncTech Solutions",
        description: "Advanced file synchronization and sharing software.",
        duration: "6 months",
        price: "0.15 ETH"
    },
    {
        name: "AIVision Pro",
        enterprise: "AI Innovators",
        description: "AI-powered computer vision software.",
        duration: "18 months",
        price: "0.375 ETH"
    },
    {
        name: "SecureWeb Suite",
        enterprise: "SecureNet Solutions",
        description: "Comprehensive web security suite.",
        duration: "12 months",
        price: "0.25 ETH"
    }
]

function App() {
    const [recoveredValue, setRecoveredValue] = useState('My Licenses');
    const [isOpen, setIsOpen] = useState(false);
    const [purchaseData, setPurchaseData] = useState({duration:""});
    const [userAddress, setUserAddress] = useState(null);


    const options = {
        injectProvider: false,
        communicationLayerPreference: 'webrtc',
    };

    const MMSDK = new MetaMaskSDK(options);
    const ethereum = MMSDK.getProvider();

    let accounts = [];

    async function ethereumButton() {
        getAccount();
    }

    async function getAccount() {
        accounts = await ethereum.request({ method: 'eth_requestAccounts' });
        setUserAddress(accounts[0]);
    }

    /*useEffect(() => {
        // Fetch the JSON file
        fetch('http://localhost:5000/user_licenses'
            ,{
                headers : {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(response => response.json())
            .then(data => {
                // Extract the desired property and update the state
                setListLicenses(data);
            })
            .catch(error => {
                console.error('Error loading JSON:', error);
            });
    }, []);

    useEffect(() => {
        // Fetch the JSON file
        fetch('http://localhost:5000/explore_licenses'
            ,{
                headers : {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(response => response.json())
            .then(data => {
                // Extract the desired property and update the state
                setListExplore(data);
            })
            .catch(error => {
                console.error('Error loading JSON:', error);
            });
    }, []);*/

    const handleButtonClick = (data) => {
        setRecoveredValue(data);
    };

    const purchaseButtonClick = (data) => {
        setPurchaseData(data);
        setIsOpen(true);
    };

    const closePopUp = () => {
        setIsOpen(false);
    };

    const handlePurchase = () => {
        setIsOpen(false);
        listLicenses = [{
            name: purchaseData.name,
            category: purchaseData.enterprise,
            description: purchaseData.description,
            status: "Purchased",
            expiration_date: "-"
        }, ...listLicenses];
    }

    return (
    <div className="flex h-screen bg-neutral-950">
        <LateralPanel handleButtonClick={handleButtonClick} address={userAddress}/>
        <Content page={recoveredValue} itemList={listLicenses} exploreList={listExplore} purchaseButtonClick={purchaseButtonClick} ethereumButton={ethereumButton} address={userAddress}/>
        <PopupWindow isOpen={isOpen} purchaseData={purchaseData} closePopUp={closePopUp} ethereumButton={ethereumButton} address={userAddress} ethereumProvider={ethereum} buyHandle={handlePurchase}/>
    </div>
  );
}

export default App;
